/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Function_Mapping_TitleInputs */

const en_options_pedal_function_mapping_title = /** @type {(inputs: Options_Pedal_Function_Mapping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Function Mapping`)
};

const fr_options_pedal_function_mapping_title = /** @type {(inputs: Options_Pedal_Function_Mapping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affectation des fonctions`)
};

const de_options_pedal_function_mapping_title = /** @type {(inputs: Options_Pedal_Function_Mapping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionszuordnung`)
};

const it_options_pedal_function_mapping_title = /** @type {(inputs: Options_Pedal_Function_Mapping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mappatura delle funzioni`)
};

const ru_options_pedal_function_mapping_title = /** @type {(inputs: Options_Pedal_Function_Mapping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функциональное сопоставление`)
};

const es_options_pedal_function_mapping_title = /** @type {(inputs: Options_Pedal_Function_Mapping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapeo de funciones`)
};

const zh_cn2_options_pedal_function_mapping_title = /** @type {(inputs: Options_Pedal_Function_Mapping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能映射`)
};

const ja_options_pedal_function_mapping_title = /** @type {(inputs: Options_Pedal_Function_Mapping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`関数マッピング`)
};

const hi_options_pedal_function_mapping_title = /** @type {(inputs: Options_Pedal_Function_Mapping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ंक्शन मैपिंग`)
};

const pt_pt2_options_pedal_function_mapping_title = /** @type {(inputs: Options_Pedal_Function_Mapping_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapeamento de funções`)
};

/**
* | output |
* | --- |
* | "Function Mapping" |
*
* @param {Options_Pedal_Function_Mapping_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_function_mapping_title = /** @type {((inputs?: Options_Pedal_Function_Mapping_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Function_Mapping_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_pedal_function_mapping_title(inputs)
	if (locale === "de") return de_options_pedal_function_mapping_title(inputs)
	if (locale === "it") return it_options_pedal_function_mapping_title(inputs)
	if (locale === "ru") return ru_options_pedal_function_mapping_title(inputs)
	if (locale === "es") return es_options_pedal_function_mapping_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_pedal_function_mapping_title(inputs)
	if (locale === "ja") return ja_options_pedal_function_mapping_title(inputs)
	if (locale === "hi") return hi_options_pedal_function_mapping_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_pedal_function_mapping_title(inputs)
	return en_options_pedal_function_mapping_title(inputs)
});